var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFsAmount = function SvgFsAmount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.445 8.318a.5.5 0 0 0 .628.197l2.424-.818a.5.5 0 0 0-.32-.948l-1.587.536C4.23 5.505 6.158 3 10 3c4.488 0 6.208 3.426 6.64 5.176a.5.5 0 1 0 .971-.24C17.129 5.984 15.159 2 10.001 2 5.727 2 3.498 4.737 2.696 6.823l-.771-1.251a.5.5 0 1 0-.851.525zm16.318 6.273a.5.5 0 0 1-.689-.163l-.771-1.251C16.5 15.263 14.273 18 10 18c-5.159 0-7.13-3.984-7.611-5.936a.5.5 0 1 1 .97-.24C3.793 13.574 5.513 17 10 17c3.842 0 5.77-2.506 6.41-4.285l-1.587.536a.5.5 0 0 1-.32-.948l2.426-.82a.5.5 0 0 1 .626.197l1.37 2.223a.5.5 0 0 1-.163.688",
    clipRule: "evenodd"
  })));
};
export default SvgFsAmount;